const updates = [
  { id: 1, date: '2026.07.31', tag: '新片上线', title: '《星际征途：新纪元》4K杜比版本正式上线' },
  { id: 2, date: '2026.07.30', tag: '系统升级', title: '播放引擎全面升级，加载速度提升40%，观影更流畅' },
  { id: 3, date: '2026.07.28', tag: '专题推荐', title: '「王家卫的光影世界」导演专题正式上线，重温经典' },
  { id: 4, date: '2026.07.26', tag: '新片上线', title: '暑期档热门动画《梦境奇缘》高清版独家首播' },
  { id: 5, date: '2026.07.24', tag: '功能更新', title: '新增「观影历史」与「收藏夹」功能，记录你的观影轨迹' },
  { id: 6, date: '2026.07.22', tag: '新片上线', title: '悬疑大作《暗夜追踪》上线三天播放量突破500万' },
  { id: 7, date: '2026.07.20', tag: '活动公告', title: '暑期观影季开启！每日签到领观影券，好片随心看' },
  { id: 8, date: '2026.07.18', tag: '新片上线', title: '经典修复版《霸王别姬》4K重制上线，致敬华语影史' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-timer-line mr-1"></i>实时快讯
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新动态</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">第一时间了解陌陌影视的最新片源、功能更新和活动资讯</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-secondary-200 space-y-8">
            {updates.map((item) => (
              <div key={item.id} className="relative">
                <div className="absolute -left-[29px] top-1 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">{item.date}</span>
                  <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                    item.tag === '新片上线' ? 'bg-accent-100 text-accent-700' :
                    item.tag === '系统升级' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '功能更新' ? 'bg-secondary-200 text-secondary-700' :
                    'bg-secondary-100 text-secondary-600'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-950 mt-2">{item.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}